import { Component, OnInit } from '@angular/core';
import {
  AdminDashboardV2VM,
  DashboardService,
} from '../../../core/services/dashboard.service';

type RangeKey = '24h' | '7d' | 'month' | 'year' | 'all';

type StatusRow = {
  key: string;
  label: string;
  count: number;
  percent: number;
  kind:
    | 'pending'
    | 'confirmed'
    | 'cooking'
    | 'delivery'
    | 'completed'
    | 'cancelled'
    | 'other';
};

type StatusPanel = {
  rangeLabel: string;
  rangeStart: string;
  rangeEnd: string;
  total: number;
  rows: StatusRow[];
};

@Component({
  selector: 'app-dashboard.component',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  // UX helpers
  loading = false;
  errorMsg: string | null = null;

  timezone = 'UTC';

  totals = {
    today: { totalOrders: 0, totalRevenue: '0.00' },
    week: { totalOrders: 0, totalRevenue: '0.00' },
    month: { totalOrders: 0, totalRevenue: '0.00' },
  };

  activeRange: RangeKey = '24h';

  statusPanels: Record<RangeKey, StatusPanel> = {
    '24h': {
      rangeLabel: 'Last 24 hours',
      rangeStart: 'NotSet',
      rangeEnd: 'NotSet',
      total: 0,
      rows: [],
    },
    '7d': {
      rangeLabel: 'Last 7 days',
      rangeStart: 'NotSet',
      rangeEnd: 'NotSet',
      total: 0,
      rows: [],
    },
    month: {
      rangeLabel: 'This month',
      rangeStart: 'NotSet',
      rangeEnd: 'NotSet',
      total: 0,
      rows: [],
    },
    year: {
      rangeLabel: 'This year',
      rangeStart: 'NotSet',
      rangeEnd: 'NotSet',
      total: 0,
      rows: [],
    },
    all: {
      rangeLabel: 'All time',
      rangeStart: 'NotSet',
      rangeEnd: 'NotSet',
      total: 0,
      rows: [],
    },
  };

  attention = {
    pending: 0,
    inProgress: 0,
    cancelled24h: 0,
  };

  get activeStatusBlock(): StatusPanel {
    return this.statusPanels[this.activeRange];
  }

  constructor(private dash: DashboardService) {}

  ngOnInit(): void {
    this.loadDashboardData();
  }

  refresh(): void {
    this.loadDashboardData();
  }

  setRange(range: RangeKey): void {
    this.activeRange = range;
  }

  private loadDashboardData(): void {
    this.loading = true;
    this.errorMsg = null;

    this.dash.getDashboardData().subscribe({
      next: (vm: AdminDashboardV2VM) => {
        this.timezone = vm.timezone;
        this.totals = vm.totals as any;
        this.statusPanels = vm.statusPanels as any;
        this.attention = vm.attention;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Dashboard fetch error:', err);
        this.errorMsg = 'Unable to load dashboard data. Please try again.';
        this.loading = false;
      },
    });
  }
}
